module.exports = __webpack_public_path__ + "static/media/bai_btn.cc65a4e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/bai_btn.png
// module id = 1467
// module chunks = 0